<script lang="ts">
    import s from './style.module.css';
    import DyButton from 'general/components/dyButton/DyButton.svelte';
    import type {ProductRecommendationType} from 'types/dy';

    export let product: ProductRecommendationType;
    export let index: number;

    const handleClick = () => {
        window.dispatchEvent(
            new CustomEvent('dynamicYield:EPopupProductClicked', {
                detail: {
                    product: {...product.productData, sku: product.sku},
                    index: index,
                },
            }),
        );
    };
    const getTitle = (fullTitle: string): string => {
        if (fullTitle.length < 19) {
            return fullTitle;
        }
        return `${fullTitle.slice(0, 17)}...`;
    };
</script>

<div class={s.slide}>
    <img
        class={s.image}
        src={product.productData.image_url}
        alt={product.productData.window_name}
    />
    <p class={s.title}>{getTitle(product.productData.window_name)}</p>
    {#if Number(product.productData.coupon_price)}
        <p class={s.price}>
            <span class={s.initialPrice}>${product.productData.price}</span>
            <span class={s.finalPrice}>${product.productData.coupon_price}</span>
        </p>
    {:else}
        <p class={s.price}>
            <span class={s.finalPrice}>${product.productData.price}</span>
        </p>
    {/if}
    <DyButton
        color="dark"
        type="link"
        rounded={true}
        href={product.productData.url}
        children="View Frame"
        size="smaller"
        onClick={handleClick}
        smallerPadding={true}
    />
</div>
